import {Page} from './Page.js';
import {Form} from './Form.js';

class PageLogin extends Page
{
	constructor ()
	{
		
		super();

		this.$frmLogin = $('#frm_login');
		this.$frmPwdReset = $('#frm_pwd_reset');

		this.$btnGoToPwdReset = $('#btn_goto_pwd_reset');
		this.$btnGoToLogin = $('#btn_goto_login');

		this.$msgContainer = $('#login_messages');

		new Form( this.$frmLogin, false );
		new Form( this.$frmPwdReset, false );

		this.bindEvents();
	}

	bindEvents ()
	{
		this.$frmLogin.on('submit', this.onLogin.bind(this));
		this.$frmPwdReset.on('submit', this.onReset.bind(this));
		this.$btnGoToPwdReset.on('click', this.goToPwdReset.bind(this));
		this.$btnGoToLogin.on('click', this.goToLogin.bind(this));
	}

	onLogin ( _e )
	{
		_e.preventDefault();

		Form.clearAllErrors( this.$frmLogin );
        this.clearMessage();

		this.$frmLogin.addClass('is-working');

		let me = this;
		
		
		let strURL = $("#btn_login").attr("data-url");
		
		
		$.ajax({

			url:strURL,
			data: $("#frm_login").serialize(),
			method: "POST",
			dataType: "json"
			
			}).done(function( _data ){

			me.$frmLogin.removeClass('is-working');

			if ( _data.success == 0 )
			{
                
                me.showMessage(_data.message, 'error');
                
                let arrState = _data.state;
                
                $.each(arrState, me.displayError.bind(me))
			}
            else
            {
                window.location.href = _data.redirect;
            }
		});
		

		//

	}

	onReset ( _e )
	{
		_e.preventDefault();

		Form.clearAllErrors( this.$frmPwdReset );
        this.clearMessage();

		this.$frmPwdReset.addClass('is-working');

        let me = this;
        
        let strURL = $("#btn_pwd_reset").attr("data-url");
		
        $.ajax({
            
            url:strURL,
            data: $("#frm_pwd_reset").serialize(),
            method: "POST",
            dataType: "json"
            
        }).done(function( _data ){
            
            console.log("onReset", _data);

			me.$frmPwdReset.removeClass('is-working');

            if ( _data.success == 0 )
            {
                
                me.showMessage(_data.message, 'error');
    
                let arrState = _data.state;
                $.each(arrState, me.displayError.bind(me))
            }
            else
			{
                me.showMessage(_data.message, 'success');
			}
        });
        

	}

	goToPwdReset ( _e )
	{
		this.clearMessage();
		this.$frmLogin.slideUp();
		this.$frmPwdReset.slideDown();
	}

	goToLogin ( _e )
	{
		this.clearMessage();
		this.$frmLogin.slideDown();
		this.$frmPwdReset.slideUp();
	}

	showMessage ( _strMsg, _strType )
	{
		this.$msgContainer.html('<p>' + _strMsg + '</p>');
		this.$msgContainer.removeClass().addClass('is-' + _strType);
	}

	clearMessage ()
	{
		this.$msgContainer.html('');
		this.$msgContainer.removeClass();
	}
    
    displayError (_index, _data)
    {
        if (_data.success != 0)
            return;
        
        let $field = $("#" + _data.field);
        
        Form.addError($field, _data.message );
        
    }
    
    static addError ( _$el, _strMsg )
    {
        Form.clearError(_$el);
        let $fieldset = _$el.parents('fieldset');
        
        $fieldset.append('<p class="error">' + _strMsg + '</p>');
        $fieldset.addClass('has-error');
    }
}

export {PageLogin};